import menu from './menu.json';
import menuItem from './templates/menu-item.hbs';

import './styles.css';

const theme = {
  LIGHT: 'light-theme',
  DARK: 'dark-theme',
};

const refs = {
  menuList: document.querySelector('.js-menu'),
  switchTheme: document.querySelector('.js-switch-input'),
  body: document.querySelector('body'),
};

const markup = menuItem(menu);

refs.menuList.insertAdjacentHTML('beforeend', markup);
refs.switchTheme.addEventListener('change', onDarkTheme);
refs.switchTheme.addEventListener('change', onLightTheme);

function onDarkTheme() {
  refs.body.classList.remove(`${theme.LIGHT}`);
  refs.body.classList.add(`${theme.DARK}`);

  localStorage.setItem('input check', refs.switchTheme.checked);
}
function onLightTheme() {
  if (!refs.switchTheme.checked) {
    refs.body.classList.remove(`${theme.DARK}`);
    refs.body.classList.add(`${theme.LIGHT}`);
    localStorage.removeItem('input check');
  }
}

const persistedSwitchInput = localStorage.getItem('input check');
if (persistedSwitchInput) {
  refs.switchTheme.checked = persistedSwitchInput;
  refs.body.classList.add(`${theme.DARK}`);
}

// function switchTheme() {
//     if (refs.switchTheme.checked) {
//       refs.body.classList.add(`${theme.DARK}`);
//       refs.body.classList.remove(`${theme.LIGHT}`);
//     } else {
//       refs.body.classList.remove(`${theme.DARK}`);
//       refs.body.classList.add(`${theme.LIGHT}`);
//     }

//     localStorage.setItem('input check', refs.switchTheme.checked);
//   }
